import { render, staticRenderFns } from "./CopyrightCaution.vue?vue&type=template&id=72490c65&"
import script from "./CopyrightCaution.vue?vue&type=script&lang=js&"
export * from "./CopyrightCaution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports